export var ToastType;
(function (ToastType) {
    ToastType["Info"] = "info";
    ToastType["Success"] = "success";
    ToastType["Warning"] = "warning";
    ToastType["Danger"] = "danger";
    ToastType["Refresh"] = "refresh";
})(ToastType || (ToastType = {}));
export class ToastService {
    static $inject = ['$translate', 'ngToast'];
    constructor($translate, ngToast) {
        'ngInject';
        this.$translate = $translate;
        this.ngToast = ngToast;
    }
    toast(type = ToastType.Info, translateKey, translateValues = {}) {
        const message = this.$translate.instant(translateKey, translateValues);
        switch (type) {
            case ToastType.Info:
            default:
                this.ngToast.info(message);
                break;
            case ToastType.Success:
                this.ngToast.success(message);
                break;
            case ToastType.Warning:
                this.ngToast.warning(message);
                break;
            case ToastType.Danger:
                this.ngToast.danger(message);
                break;
            case ToastType.Refresh:
                this.ngToast.refresh(message);
                break;
        }
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
ToastService.$inject = ['$translate', 'ngToast'];
